import { PaperGenMethodEnum } from "../../common";
import { DifficultyDistribution, QuestionReqModel } from "./question-req-model";
import { SetAndQuestionMappingsModel } from "./set-and-section-mappings";

export class CreateQuestionPaperReq {
    qnpModelId: number;
    qnos: string;
    subject: number;
    noOfSets: number;
    generateOtherLanguagePapers: boolean;
    paperBundlerId?: string;
    sectionQuestionMappings: SetAndQuestionMappingsModel[];
    generationMethod: PaperGenMethodEnum;
    userId?: number;
    difficulty: DifficultyDistribution;
    constructor(qnpModelId: number, subject: number, noOfSets: number, sectionQuestionMappings: SetAndQuestionMappingsModel[], qnos: string, generateOtherLanguagePapers: boolean, generationMethod: PaperGenMethodEnum, paperBundlerId?: string, userId?: number, difficulty?: DifficultyDistribution) {
        this.qnpModelId = qnpModelId;
        this.sectionQuestionMappings = sectionQuestionMappings;
        this.qnos = qnos;
        this.subject = subject;
        this.noOfSets = noOfSets;
        this.generateOtherLanguagePapers = generateOtherLanguagePapers;
        this.paperBundlerId = paperBundlerId;
        this.generationMethod = generationMethod;
        this.userId = userId;
        this.difficulty = difficulty ?? new DifficultyDistribution(0, 0, 0);
    }
}